module.exports = __webpack_public_path__ + "public/img/hangyeshebeikaijilv.1be7fc64.png";